<template>
    <div class="dc-dpresentations">
        <app-docs :docs="dpresentations" :list="false"></app-docs>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import Dpresentations from './dpresentations.json'
import ShareButton from "../shared/ShareButton";
import Docs from "../shared/Docs";
export default {
  components: {
    appShareButton: ShareButton,
    appDocs: Docs
  },
  data() {
      return {
          dpresentations: Dpresentations
      }
  }
};</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/download-center/Dpresentations.vue